import { Routes } from '@angular/router';
import { CookieSettingsGuard } from '@teamfoster/sdk/cookie-ngrx';
import { DictionaryGuard } from '@teamfoster/sdk/dictionary-ngrx';
import { MenuGuard } from '@teamfoster/sdk/menu-ngrx';
import { NotFoundComponent } from './404.component';
import { LocationGuard } from './location/guards';
import { SocialChannelsGuard } from './social-media/guards';
import { menuThemeGuard, resetMenuThemeGuard } from './guards/menu-theme.guard';
import { WebsiteLayoutComponent } from './layouts/website-layout/website-layout.component';
import { EmptyLayoutComponent } from './layouts/empty-layout/empty-layout.component';
import { FstrGuard } from '@teamfoster/sdk/routing-utility';

const appGuards = [CookieSettingsGuard, DictionaryGuard, MenuGuard, LocationGuard, SocialChannelsGuard, menuThemeGuard];

export const routes: Routes = [
  {
    path: 'narrowcasting',
    component: EmptyLayoutComponent,
    canActivate: [DictionaryGuard, FstrGuard],
    pathMatch: 'prefix',
    children: [
      {
        path: '',
        loadChildren: () => import('./narrowcasting/narrowcasting.routes').then(m => m.routes),
      },
    ],
  },
  {
    path: '',
    component: WebsiteLayoutComponent,
    pathMatch: 'prefix',
    canActivate: [...appGuards],
    children: [
      {
        path: 'styleguide',
        loadChildren: () => import('./styleguide/styleguide.routes').then(m => m.routes),
        canDeactivate: [resetMenuThemeGuard],
      },
      {
        path: 'contentblokken',
        pathMatch: 'prefix',
        loadChildren: () => import('./content-blocks/content-blocks.routes').then(m => m.routes),
        canDeactivate: [resetMenuThemeGuard],
        data: {
          reuseComponent: true,
        },
      },
      {
        path: 'agenda',
        loadChildren: () => import('./events/events.routes').then(m => m.routes),
        canDeactivate: [resetMenuThemeGuard],
      },
      {
        path: 'pagina',
        loadChildren: () => import('./content/content.routes').then(m => m.routes),
        canDeactivate: [resetMenuThemeGuard],
      },
      {
        path: 'nieuws',
        loadChildren: () => import('./news/news.routes').then(m => m.routes),
        canDeactivate: [resetMenuThemeGuard],
      },
      {
        path: 'faq',
        loadChildren: () => import('./faq/faq.routes').then(m => m.routes),
        canDeactivate: [resetMenuThemeGuard],
      },
      {
        path: 'museum/collecties',
        loadChildren: () => import('./museum-collections/museum-collections.routes').then(m => m.routes),
        canDeactivate: [resetMenuThemeGuard],
      },
      {
        path: 'zoeken',
        loadChildren: () => import('./search/search.routes').then(m => m.routes),
        canDeactivate: [resetMenuThemeGuard],
      },
      {
        path: '404',
        component: NotFoundComponent,
      },
      {
        path: '',
        pathMatch: 'prefix',
        loadChildren: () => import('./landing-pages/landing-pages.routes').then(m => m.routes),
        canDeactivate: [resetMenuThemeGuard],
      },
      {
        path: '**',
        redirectTo: '/404',
      },
    ],
  },
];
